{
  "name": "loan-renewal-fe",
  "version": "4.7.2",
  "type": "module",
  "scripts": {
    "install": "cp ./package.json ./src/assets",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --coverage",
    "watch": "ng test",
    "lint": "ng lint",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.1",
    "@angular/common": "^22.1.1",
    "@angular/compiler": "^22.1.1",
    "@angular/core": "^22.1.1",
    "@angular/forms": "^22.1.1",
    "@angular/material": "^22.1.1",
    "@angular/platform-browser": "^22.1.1",
    "@angular/platform-browser-dynamic": "^22.1.1",
    "@angular/router": "^22.1.1",
    "rxjs": "~7.5.0",
    "tslib": "^2.0.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.1.3",
    "@angular/cdk": "^22.1.1",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.1",
    "@angular/material-luxon-adapter": "^22.1.1",
    "@eslint/js": "^10.0.1",
    "@sparbanken-syd/auth-backend": "^2.6.5",
    "@sparbanken-syd/loan-renewal-be": "^6.0.0",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/renewal-tool": "^4.3.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@types/luxon": "^3.3.2",
    "@types/node": "^24",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "@typescript-eslint/utils": "^8.33.1",
    "@vitest/coverage-v8": "^5.0.1",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.2.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "luxon": "^3.4.2",
    "postcss": "^8.5.9",
    "postcss-scss": "^4.0.9",
    "stylelint": "^17.6.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.33.1",
    "vite": "^8.3.0",
    "vitest": "^5.0.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz"
  }
}
